// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { CostiPerMissioneDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class CostiPerMissioneApiClient extends BaseCRUDApiClient<CostiPerMissioneDto> {
  baseUrl = this.config.apiEndpoint + '/costi-per-missione';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
